export enum Employees {
  GET_EMPLOYEES_REQUEST = '@employees/GET_EMPLOYEES_REQUEST',
  GET_EMPLOYEES_SUCCESS = '@employees/GET_EMPLOYEES_SUCCESS',
  GET_EMPLOYEES_FAIL = '@employees/GET_EMPLOYEES_FAIL',

  GET_ACTION_REQUIRED_EMPLOYEES_COUNT_REQUEST = '@employees/GET_ACTION_REQUIRED_EMPLOYEES_COUNT_REQUEST',
  GET_ACTION_REQUIRED_EMPLOYEES_COUNT_SUCCESS = '@employees/GET_ACTION_REQUIRED_EMPLOYEES_COUNT_SUCCESS',
  GET_ACTION_REQUIRED_EMPLOYEES_COUNT_FAIL = '@employees/GET_ACTION_REQUIRED_EMPLOYEES_COUNT_FAIL',
}
